/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BillingSourceSystem {
  CCP = "CCP",
  HAMS = "HAMS",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: useGetTenantDataFromCGraphQLQuery
// ====================================================

export interface useGetTenantDataFromCGraphQLQuery_license {
  billingSourceSystem: BillingSourceSystem | null;
  trialEndDate: string | null;
  firstPredunningEndTime: any | null;
}

export interface useGetTenantDataFromCGraphQLQuery {
  license: useGetTenantDataFromCGraphQLQuery_license | null;
}
